/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * Createtoken Input Action
 */
export interface TokenRequest {
    grant_type: string;
    client_id: string;
    client_secret: string;
    resource: string;
}
export class CreatetokenInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `TODO`;
    public getCacheObjectType = () => 'TODO';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface ICreatetokenData {
    token: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new CreatetokenInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: CreatetokenInput, ctx: Msdyn365.IActionContext): Promise<ICreatetokenData> {
    return { token: '' };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICreatetokenData>>action,
    // TODO: Give your data action a unique id
    id: 'Createtoken',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
